import React from 'react';

import { TbX } from 'react-icons/tb';

import { v4 as uuidv4 } from 'uuid';

import { twMerge } from 'tailwind-merge';

import Icon from 'components-new/icon/icon';

interface FloatingActionBarProps {
  visible: boolean;
  className?: string;
  onCloseClicked?: () => void;
  children: React.ReactNode[];
}

const FloatingActionBar: React.FC<FloatingActionBarProps> = ({
  visible,
  className,
  children,
  onCloseClicked,
}) => {
  if (!Array.isArray(children) || children.length < 1 || children.length > 4) {
    throw new Error(
      'FloatingActionBar should have between 1 and 4 child elements.',
    );
  }

  const childrenWithSeparators: React.ReactNode[] = [];
  children.forEach((child, i) => {
    if (i !== 0) {
      childrenWithSeparators.push(
        <div
          key={uuidv4()}
          className="mx-1 border-b w-full sm:border-l sm:w-auto h-0 sm:h-[20px]"
        />,
      );
    }

    if (React.isValidElement(child)) {
      childrenWithSeparators.push(React.cloneElement(child, { key: uuidv4() }));
    } else {
      childrenWithSeparators.push(child);
    }
  });

  const containerClassName = twMerge(
    'fixed transition-all duration-300',
    'flex flex-col sm:flex-row gap-2 items-center min-w-max',
    visible
      ? 'translate-y-0 opacity-100 pointer-events-auto'
      : 'translate-y-full opacity-0 pointer-events-none',
    'left-1/2 transform -translate-x-1/2 bottom-20 py-3 px-2 sm:px-8',
    'z-50 mx-auto border rounded-2xl shadow-[0px_2px_10px_0px_rgba(25,23,26,0.24)] bg-white',
    className,
  );

  return (
    <div className={containerClassName}>
      {childrenWithSeparators}

      {onCloseClicked && (
        <button
          type="button"
          onClick={onCloseClicked}
          className="absolute right-0 top-0 mx-2 my-1"
        >
          <Icon icon={TbX} size={14} className="text-gray-500" />
        </button>
      )}
    </div>
  );
};

export default FloatingActionBar;
